export default "__VITE_ASSET__713661c2__"